import React from "react";
import "./CompanyMetrics.scss"
import { useFetch } from "../../utils/hooks";
import { getMetricsIcon } from "../../utils/images";
import { formatMetric } from "../../utils/utils";
import { getMetrics } from "../../services/user";
import { getPartnerProfit } from "../../services/shipments";

const MetricWrapper = ({ metric, icon }) => {
  const formattedMetric = formatMetric(icon);
  return (
    <div className="MetricWrapper">
      <span><img src={getMetricsIcon(icon)} /></span>
      <div className="info-wrapper">
        <div className="title">{formattedMetric.prefix}{metric} <span className="hrs">{formattedMetric.suffix}</span></div>
        <div className="subtitle">{formattedMetric.subtitle}</div>
      </div>
    </div>
  )
}


const CompanyMetrics = () => {
  const { data, loading } = useFetch(getMetrics);
  const { data: dataProfit, loading: loadingProfit } = useFetch(getPartnerProfit);

  const metrics = data?.metrics
  const profit = dataProfit?.profit

  if (loading || loadingProfit || (!metrics && !profit)) return <></>

  return (
    <div className="CompanyMetrics">
      {
        metrics && (
          Object.keys(metrics).map(k => <MetricWrapper key={k} metric={metrics[k]} icon={k} />)
        )
      }
      {
        profit && (<MetricWrapper metric={profit} icon={"profit"} />)
      }
    </div>
  )
}

export default CompanyMetrics
